<svg fill="none" height="24" viewBox="0 0 23 24" width="23" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.29864 10.3615C12.1326 10.3615 14.4352 8.05889 14.4352 5.22494C14.4352 2.39099 12.1326 0.0884095 9.29864 
    0.0884095C6.46469 -0.000151426 4.16211 2.30243 4.16211 5.13638C4.16211 8.05889 6.46469 10.3615 9.29864 10.3615Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M11.8672 19.2174C11.8672 15.7635 14.6125 13.0181 18.0664 13.0181C19.0406 13.0181 20.0148 13.2838 20.8118 
    13.638C19.9262 12.7524 19.3948 12.3982 17.4465 12.3982H6.73063C3.01107 12.3982 0 14.7008 0 17.5347V20.9C0 
    21.3428 0.442804 21.6971 0.97417 21.6971H9.38745H9.56458C9.91882 21.6971 10.6273 21.6971 12.31 
    21.6971C12.0443 20.9 11.8672 20.103 11.8672 19.2174Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M18.0666 14.2581C15.4098 14.2581 13.1958 16.4721 13.1958 19.1289C13.1958 21.7857 15.4098 23.9998 18.0666 
    23.9998C20.7235 23.9998 22.9375 21.7857 22.9375 19.1289C22.9375 16.3835 20.812 14.2581 18.0666 14.2581ZM21.2548 
    20.2802H19.3065V22.3171H16.9154V20.2802H14.967V17.9776H16.9154V15.9407H19.3065V17.9776H21.2548V20.2802Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
